import { render, staticRenderFns } from "./navlink.vue?vue&type=template&id=086d10cb"
import script from "./navlink.vue?vue&type=script&lang=js"
export * from "./navlink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports